export const USER_AUTHORIZATION = "USER_AUTHORIZATION";
export const OPEN_LOGIN_MODAL = "OPEN_LOGIN_MODAL";
export const OPEN_REGISTRATION_MODAL = "OPEN_REGISTRATION_MODAL";
export const CLOSE_AUTH_MODAL = "CLOSE_AUTH_MODAL";
export const UPDATE_COOKIE_FILE_IS_OK = "UPDATE_COOKIE_FILE_IS_OK";
export const LOG_OUT = "LOG_OUT";

export const CHANGE_SHARE_MODAL_INFO = "CHANGE_SHARE_MODAL_INFO";

export const UPDATE_WHEEL_PRIZES = "UPDATE_WHEEL_PRIZES";

export const UPDATE_TICKET_COUNT = "UPDATE_TICKET_COUNT";
export const UPDATE_COIN_COUNT = "UPDATE_COIN_COUNT";

export const UPDATE_MAINTENANCE_MODAL_OPEN = "UPDATE_MAINTENANCE_MODAL_OPEN";
